import React from 'react';
import { ScaleIcon } from 'lucide-react';
import { comparisonRows } from '../data/content';
export function Comparison() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-32" data-mp="1g8ue71hjjvos">
      <div className="mx-auto w-full max-w-5xl px-5 text-center md:px-8" data-id="element-33" data-mp="1l6vyfpqpe11u">
        <h2 className="mx-auto inline-flex max-w-4xl flex-wrap items-center justify-center gap-3 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 md:text-5xl" data-id="element-34" data-mp="1l5kxdxon77ef">
          <ScaleIcon className="h-8 w-8 text-blue-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-35" data-mp="1uwxje8nrf3cj" />
          Estudiar como siempre vs estudiar con el Atlas
        </h2>

        <div className="mx-auto mt-12 max-w-4xl overflow-x-auto rounded-xl ring-1 ring-gray-200" data-id="element-36" data-mp="23yyizc6gu1hd">
          <table className="w-full min-w-[32rem] border-collapse text-left" data-id="element-37" data-mp="28vxaro2npwce">
            <caption className="sr-only" data-id="element-38" data-mp="9ke1t9hcso2q">
              Comparación entre el estudio tradicional y el Atlas Visual de Instrumentación
              Quirúrgica
            </caption>
            <thead data-id="element-39" data-mp="1m0pay7p819df">
              <tr className="bg-gray-50" data-id="element-40" data-mp="1m18wdye2yfw7">
                <th scope="col" className="px-5 py-4 text-sm font-bold text-gray-500 md:px-6" data-id="element-41" data-mp="1m2a9s9ikjeh3">
                  Estudio tradicional
                </th>
                <th scope="col" className="bg-blue-100 px-5 py-4 text-sm font-bold text-blue-800 md:px-6" data-id="element-42" data-mp="1d7vsk1eh9tvc">
                  Atlas Visual
                </th>
              </tr>
            </thead>
            <tbody data-id="element-43" data-mp="24ys6l5c9y4k7">
              {comparisonRows.map(row => <tr key={row.old} className="border-t border-gray-200 bg-white" data-id="element-44" data-mp="20z180fgiak54">
                  <td className="px-5 py-4 text-gray-500 md:px-6" data-id="element-45" data-mp="1vydhrw03q7by">{row.old}</td>
                  <td className="bg-blue-50 px-5 py-4 font-semibold text-blue-800 md:px-6" data-id="element-46" data-mp="1qzshjwkunnni">
                    {row.atlas}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mx-auto mt-12 max-w-2xl" data-id="element-47" data-mp="fjlprk6vb236">
          <p className="text-xl font-bold leading-snug tracking-tight text-gray-900 md:text-2xl" data-id="element-48" data-mp="fmzu2xz3dld9">
            No estudies instrumental como una lista de nombres.
          </p>
          <p className="mt-2 text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-4xl" data-id="element-49" data-mp="m0dj7by6skw8">
            Aprende a reconocerlo.
          </p>
        </div>
      </div>
    </section>;
}